<template>
  <div>
    {{ foundOn }}
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { PlantJson } from '@/data/plants/PlantJson.ts';

export default {
  name: 'FoundOnCell',
  props: {
    plantJson: {
      type: Object as PropType<PlantJson>,
      required: true,
    },
  },
  computed: {
    foundOn() {
      if (!this.plantJson.issue) {
        return;
      }

      return this.plantJson.issue.found_on.substr(0, 10);
    },
  },
};
</script>

<style scoped></style>
